import { Plugin } from '@ckeditor/ckeditor5-core';
import { WidgetResize } from '@ckeditor/ckeditor5-widget';
import RecorderLoadObserver from '../recorder/recorderloadobserver';

const RESIZABLE_RECORDERS_CSS_SELECTOR =
    'figure.recorder.ck-widget > audio,' +
    'figure.recorder.ck-widget > video,' +
    'figure.recorder.ck-widget > a > audio,' +
    'figure.recorder.ck-widget > a > video';

const RECORDER_WIDGETS_CLASSES_MATCH_REGEXP = /recorder/;
const RESIZED_RECORDER_CLASS = 'recorder_resized';

export default class RecorderResizeHandles extends Plugin {
    static get requires() {
        return [ WidgetResize ];
    }

    static get pluginName() {
        return 'RecorderResizeHandles';
    }

    init() {
        const command = this.editor.commands.get('resizeRecorder');
        this.bind('isEnabled').to(command);

        this._setupResizerCreator();
    }

    _setupResizerCreator() {
        const editor = this.editor;
        const editingView = editor.editing.view;

        editingView.addObserver(RecorderLoadObserver);

        this.listenTo(editingView.document, 'recorderLoaded', (evt, domEvent) => {
            if (!domEvent.target.matches(RESIZABLE_RECORDERS_CSS_SELECTOR)) {
                return;
            }

            const domConverter = editor.editing.view.domConverter;
            const recorderView = domConverter.domToView(domEvent.target);

            const widgetView = recorderView.findAncestor({
                classes: RECORDER_WIDGETS_CLASSES_MATCH_REGEXP
            });

            if (!widgetView) {
                return;
            }

            let resizer = editor.plugins.get(WidgetResize).getResizerByViewElement(widgetView);

            if (resizer) {
                resizer.redraw();
                return;
            }

            const mapper = editor.editing.mapper;
            const recorderModel = mapper.toModelElement(widgetView);

            resizer = editor.plugins.get(WidgetResize).attachTo({
                unit: editor.config.get('recorder.resizeUnit') || '%',
                modelElement: recorderModel,
                viewElement: widgetView,
                editor,

                // Host de las manijas
                getHandleHost(domWidgetElement) {
                    return domWidgetElement;
                },

                // El área real que se redimensiona
                getResizeHost(domWidgetElement) {
                    return domWidgetElement;
                },

                isCentered() {
                    const alignment = recorderModel.getAttribute('alignment');
                    return alignment === 'center';
                },

                onCommit(newValue) {
                    editor.execute('resizeRecorder', { width: newValue });
                }
            });

            resizer.on('updateSize', () => {
                if (!widgetView.hasClass(RESIZED_RECORDER_CLASS)) {
                    editingView.change(writer => {
                        writer.addClass(RESIZED_RECORDER_CLASS, widgetView);
                    });
                }
            });

            resizer.bind('isEnabled').to(this);
        });
    }
}
